/* Rquiere de mixin.js */

var product = {
	data () {
		return {
			listProducts: [],
			methodsProduct: {
                create: 'product/register',
				delete: '/delete',
				get: 'products',
				show: 'product/',
			},
            objectProduct: {
                exists: 0,
                id: 0,
                name: '',
                synthetic:  null,
                isbn:  null,
                length:  '',
                width:  '',
                height:  '',
                weight:  '',
                img:  '',
                group:  'U',
                status_id:  '',
                status:  '',
                type_product_id:  '',
                type_product:  '',
                editorial_id:  '',
                editorial:  '',
                type_binding_id:  '',
                type_binding:  '',
                product_locations:  [],
                product_price_list:  []
            },
			paginationProducts: [],
            qRowsProduct: 25,
			searchProducts: '',
            searchingProduct: false,
            productIdSelected: 0
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        addListProducts(newProduct) {
            this.listProducts.unshift(newProduct)
            if(this.listProducts.length > this.qRowsProduct) {
                this.listProducts.splice(this.qRowsProduct, 1)
            }
        },
		axiosLocalProductResult(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllProductsResult': this.getAllProductsResult(response); break;
				case 'getProductResult': this.getProductResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
        changeQRowsProduct() {
            localStorage.setItem('qRowsProduct', this.qRowsProduct)
            this.getAllProducts()
        },
        clearObjectProduct() {
            this.objectProduct.exists = 0
            this.objectProduct.id = 0
            this.objectProduct.name = ''
            this.objectProduct.synthetic = null
            this.objectProduct.isbn = null
            this.objectProduct.length = ''
            this.objectProduct.width = ''
            this.objectProduct.height = ''
            this.objectProduct.weight = ''
            this.objectProduct.img = ''
            this.objectProduct.group = 'U'
            this.objectProduct.status_id = ''
            this.objectProduct.status = ''
            this.objectProduct.type_product_id = ''
            this.objectProduct.type_product = ''
            this.objectProduct.editorial_id = ''
            this.objectProduct.editorial = ''
            this.objectProduct.type_binding_id = ''
            this.objectProduct.type_binding = ''
            this.objectProduct.product_locations = []
            this.objectProduct.product_price_list = []
            this.objectProduct.created_at = ''
            this.objectProduct.updated_at = ''
        },
		deleteProduct(id) {
			this.$emit('showLockScreen', 'Borrando product . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsProduct.show + id + this.methodsProduct.delete, 'DELETE', 'deleteProductResult')
		},
        deleteProductResult(response) {
			if(response.data.success) {
                this.$snotify.warning('Se ha borrado el producto ' + response.data.data + ' con exito!!!', 'Borrado')
				this.deleteItemListProduct(response.data.data)
				this.socketEmit(['DELETE_PRODUCT'], response.data.data)
			}
            this.deleteProductResultLocal(response)
        },
        deleteProductResultLocal(response) {
            console.log('deleteProductResultLocal no desarrollado', response)
        },
        deleteItemListProduct(id) {
			let index = this.listProducts.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let productDeleted = this.listProducts.splice(index,1)
        },
		getAllProducts(page = 1) {
            this.searchingProduct = true
            this.listProducts = []
			let parameters = '?search=' + this.searchProducts + '&page=' + page + '&qRow=' + this.qRowsProduct
            this.$emit('showLockScreen', 'Obteniendo lista de Productos . . .')
            let url = this.getApiBackend + this.methodsProduct.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllProductsResult')
        },
        getAllProductsWithPriceList(search, priceListId, page = 1) {
            this.searchingProduct = true
            this.listProducts = []
			let parameters = '?search=' + search + '&page=' + page + '&qRow=' + this.qRowsProduct
            let url = this.getApiBackend + this.methodsProduct.get + '/withPriceList/' + priceListId + parameters
            this.axiosActionIS(url, 'GET', 'getAllProductsResult')
        },
		getAllProductsResult(response) {
			this.$emit('hideLockScreen')
            this.searchingProduct = false
            if(response.data.success) {
                this.listProducts = response.data.data
                this.paginationProducts = response.data.paginate    
            }
            this.getAllProductsResultLocal(response)
		},
        getAllProductsResultLocal(response) {
            console.log('getAllProductsResultLocal no desarrollado', response)
        },
		getProduct(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsProduct.show + id, 'GET', 'getProductResult')
		},
        getProductResult(response) {
            this.$emit('hideLockScreen')
            if(response.data.success) {
                this.setObjectProduct(response.data.data)
            }
            this.getProductResultLocal(response)
        },
        getProductResultLocal(response) {
            console.log('getProductResultLocal no está desarrollado', response)
        },
		saveProduct() {
			let method = (this.objectProduct.exists == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if(method == 'POST') {
				this.axiosActionIS(this.getApiBackend + this.methodsProduct.create, method, 'saveProductResult', this.objectProduct)
			} else {
				this.axiosActionIS(this.getApiBackend + this.methodsProduct.show + this.objectProduct.id, method, 'saveProductResult', this.objectProduct)
            }
		},
        saveProductResult(response) {
            if(!response.data.success) {
                this.$snotify.error(response.data.data, response.data.message)
            } else {
                if(response.data.message == 'NUEVO') {
                    this.setObjectProduct(response.data.data)
                    this.addListProducts(response.data.data)
                    this.socketEmit(['NEW_PRODUCT'], response.data.data)
                } else if(response.data.message == 'ACTUALIZADO') {
                    this.updateItemListProducts(response.data.data)
                    this.socketEmit(['UPDATE_PRODUCT'], response.data.data)
                }
                this.saveProductResultLocal(response)
            }
        },
        saveProductResultLocal(response) {
            console.log('saveProductResultLocal no desarrollado', response)
        },
        saveProductLocation(item) {
            let index = this.listProducts.map((el) => parseInt(el.id)).indexOf(parseInt(item.product_id))
            if(index > -1) {
                this.listProducts[index].product_locations.push(item)
                this.setObjectProduct(this.listProducts[index])
                console.log(this.listProducts[index].product_locations)
            }
        },
		setListeningProduct() {
			this.sockets.subscribe('DELETE_PRODUCT', (data) => { this.deleteItemListProduct(data.body) })
			this.sockets.subscribe('NEW_PRODUCT', (data) => { this.addListProducts(data.body) })
			this.sockets.subscribe('UPDATE_PRODUCT', (data) => { this.updateItemListProducts(data.body) })
		},
        setObjectProduct(item) {
			for (const property in item) {
				this.objectProduct[property] = item[property]
			}
        },
		showProduct(id, action = 'view') {
            this.searchingProduct = true
            let param = '?action=' + action
			this.axiosActionIS(this.getApiBackend + this.methodsProduct.show + id + param, 'GET', 'showProductResult', null)
		},
        showProductResult(response) {
            this.searchingProduct = false
            if(response.data.success == true) {
                this.setObjectProduct(response.data.data)
            }
            this.showProductResultLocal(response)
        },
        showProductResultLocal(response) {
            console.log('showProductResultLocal no desarrollado', response)
        },
        updateItemListProducts(item) {
			let index = this.listProducts.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
            if(index > -1) {
                for (const property in item) {
                    this.listProducts[index][property] = item[property]
                }
            }
            if(this.objectProduct.id == item.id) {
                this.setObjectProduct(item)
            }
        }
	},
};

export default product;